import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const associationSuccess = payload => {
  return {
    type: actionTypes.ASSOCIATIONS_SUCCESS,
    payload: payload
  };
};

export const associationStart = () => {
  return {
    type: actionTypes.ASSOCIATIONS_START
  };
};

export const associationFail = error => {
  return {
    type: actionTypes.ASSOCIATIONS_FAIL,
    error: error
  };
};
export const getAssociationsList = (getData, hideLoader) => {
  return dispatch => {
    if (!(hideLoader !== undefined && hideLoader === true)) {
      //dispatch(associationStart());
    }
    axiosInstance()
      .get('/associations.json', { params: getData })
      .then(response => {
        dispatch(associationSuccess({ ...response.data, loaded: true }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(associationFail(err.response.data.message));
        } else {
          dispatch(associationFail('Problem with connection to API.'));
        }
      });
  };
};

export const createAssociation = (postData, history) => {
  return dispatch => {
    dispatch(associationStart());
    axiosInstance()
      .post('/associations.json', postData)
      .then(response => {
        history.push('/associations/' + response.data.id);
        dispatch(associationSuccess({ list: [], loaded: false }));
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(associationFail(err.response.data.message));
        } else {
          dispatch(associationFail('Problem with connection to API.'));
        }
      });
  };
};

export const editAssociation = (entityId, postData, callback) => {
  return dispatch => {
    dispatch(associationStart());
    axiosInstance()
      .put(`/associations/${entityId}.json`, postData)
      .then(response => {
        dispatch(associationSuccess({ viewItem: response.data }));
        dispatch(associationSuccess({ list: [], loaded: false }));
        callback();
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(associationFail(err.response.data.message));
        } else {
          dispatch(associationFail('Problem with connection to API.'));
        }
      });
  };
};

export const getAssociation = entityId => {
  return dispatch => {
    //dispatch(loaderStart());
    axiosInstance()
      .get('/associations/' + entityId + '.json')
      .then(response => {
        dispatch(associationSuccess({ viewItem: response.data }));
        //dispatch(loaderStop());
      })
      .catch(err => {
        if (err.response !== undefined) {
          dispatch(associationFail(err.response.data.message));
        } else {
          dispatch(associationFail('Problem with connection to API.'));
        }
        //dispatch(loaderStop());
      });
  };
};
